import React from "react";
import { Field, Form, Formik } from "formik";
import { useCookies } from "react-cookie";
import * as Yup from "yup";
import { patchData, postData } from "../../../../../../services";
import SelectDropdown from "../../../../../molecules/Dropdown";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../../../assets/styles/toast";
import TagInput from "../../../../../molecules/TagInput";

const UserForm = ({ onClose, initialValues, id, refetchData }) => {
  const [cookies] = useCookies(["b_t"]);

  const initialData = {
    name: initialValues?.name || null,
    types: null,
  };

  const validationSchema = Yup.object().shape({
    name: initialValues
      ? Yup.string().required("Invitee Type is required")
      : Yup.mixed().notRequired(),
    types: initialValues
      ? Yup.mixed().notRequired()
      : Yup.array()
          .of(Yup.string().required("Each Invitee Type is required"))
          .min(1, "At least one Invitee Type is required")
          .required("At least one Invitee Type is required"),
  });

  const handleSubmit = async (values) => {
    try {
      const res = await postData({
        endpoint: "BusinessConfiguration/addInviteeType",
        token: cookies.b_t,
        data: values.types,
        params: { ...values, business_id: cookies.bid },
      });

      if (res?.data?.status) {
        toast.success("Invitee Type Added Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        onClose();
        refetchData();
      } else {
        toast.error(res?.data?.message, { style: errorStyles, duration: 1000 });
        onClose();
      }
    } catch (e) {
    } finally {
      onClose();
    }
  };

  const handleEdit = async (values) => {
    try {
      const res = await patchData({
        endpoint: "BusinessConfiguration/editInviteeType",
        token: cookies.b_t,
        data: values,
        params: { id: id, ...values },
      });

      if (res.status) {
        toast.success("Invitee Type Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
      } else {
        toast.error(res.message, { style: confimationStyles, duration: 1000 });
      }

      onClose();
    } catch (error) {}
  };

  return (
    <Formik
      initialValues={initialData}
      validationSchema={validationSchema}
      key={id}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({
        dirty,
        isValid,
        values,
        errors,
        setFieldValue,
        handleBlur,
        handleChange,
      }) => (
        <Form>
          {initialValues ? (
            <div className="form-group">
              <label htmlFor="name">Invitee Type</label>
              <Field
                type="text"
                id="name"
                name="name"
                placeholder="Enter Invitee Type"
              />
            </div>
          ) : (
            <div className="form-group">
              <label htmlFor="name">Invitee Type</label>
              <TagInput
                placeholder="Add Invitee Type and Press Enter"
                onChange={(values) => {
                  setFieldValue("types", values);
                }}
              />
            </div>
          )}

          <div className="d-flex justify-content-end mt-3">
            {initialValues ? (
              <button
                type="button"
                className="btn btn-primary"
                disabled={!isValid}
                onClick={() => handleEdit(values)}
              >
                Update
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary w-30"
                disabled={!isValid || !dirty}
                onClick={() => handleSubmit(values)}
              >
                Add
              </button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UserForm;
